<template>
  <v-alert v-if="errors.length !== 0" dense outlined type="error">
    <div
      v-for="(error, index) in errors"
      :key="index"
      class="text-caption mb-1"
    >
      ・ {{ error }}
    </div>
  </v-alert>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      required: true
    }
  }
}
</script>
